module.exports = __webpack_public_path__ + "static/media/Journey__set_of_23_CDs-s.055776a3.jpg";